import Vue from 'vue';
import axios from 'axios';
import store from '@/store'

const baseURL = process.env.VUE_APP_ENGINE_URL;
let taskLocked = false;

const apiUsername = process.env.VUE_APP_ENGINE_API_USER;
const apiPassword = process.env.VUE_APP_ENGINE_API_PASS;
const apiToken = Buffer.from(`${apiUsername}:${apiPassword}`, 'utf8').toString('base64');

const state = {
  myTasks: [],
  myTasksCount: null,
  myTasksFollowUp: null,
  myTasksFollowUpIds: [],
  myTasksOverdue: null,
  myTasksOverdueIds: [],
  allTasks: [],
  allTasksCount: null,
  allTasksFollowUp: null,
  allTasksFollowUpIds: [],
  allTasksOverdue: null,
  allTasksOverdueIds: [],
  unassignedTasks: [],
  unassignedTasksCount: null,
  unassignedTasksFollowUp: null,
  unassignedTasksFollowUpIds: [],
  unassignedTasksOverdue: null,
  unassignedTasksOverdueIds: [],
  claimtask: '',
  taskId: '',
  taskName: '',
  formKey: '',
  processKey: '',
  processVersion: null,
  externalProcessVersion: null,
  processName: '',
  deployedForm: {},
  extScript: '',
  savedGridLayout: '',
  sqlQueries: [],
  processVars: [],
  uploadedForm: [],
  taskData: [],
  completedTask: [],
  savedTask: [],
  candidateGroups: [],
  candidateUsers: [],
  reassignedStatus: '',
  historicTasks: [],
  teamTasks: [],
  teamTasksCount: null,
  teamTasksFollowUp: null,
  teamTasksFollowUpIds: [],
  teamTasksOverdue: null,
  teamTasksOverdueIds: [],
  previewLoaded: false,
  allForms: [],
  processForms: [],
  formAction: '',
  formTitle: '',
  formId: null,
  deletedForm: null,
  copiedForm: null,
  subformList: [],
  subformExtScript: '',
  subformSchema: {},
  subformTitle: '',
  subformLayout: '',
  subformQueries: [],
  markedForms: '',
  unmarkedForms: '',
  caseId: '',
  bulkReassign: '',
  gridRowAdded: false,
  exportedForm: [],
  importFormSaved: false,
  editingForm: false,
  formDeployed: false,
  formLocked: false,
  formLockedUser: '',
  lockedForms: [],
  apiReturnData: [],
  apiAuthCode: '',
  veridasResp: [],
  taskComplete: null,
  promoteFormData: [],
  promoteFormRes: []
};

const getters = {
  myTasks: (state) => state.myTasks,
  myTasksCount: (state) => state.myTasksCount,
  myTasksFollowUp: (state) => state.myTasksFollowUp,
  myTasksFollowUpIds: (state) => state.myTasksFollowUpIds,
  myTasksOverdue: (state) => state.myTasksOverdue,
  myTasksOverdueIds: (state) => state.myTasksOverdueIds,
  allTasks: (state) => state.allTasks,
  allTasksCount: (state) => state.allTasksCount,
  allTasksFollowUp: (state) => state.allTasksFollowUp,
  allTasksFollowUpIds: (state) => state.allTasksFollowUpIds,
  allTasksOverdue: (state) => state.allTasksOverdue,
  allTasksOverdueIds: (state) => state.allTasksOverdueIds,
  unassignedTasks: (state) => state.unassignedTasks,
  unassignedTasksCount: (state) => state.unassignedTasksCount,
  unassignedTasksFollowUp: (state) => state.unassignedTasksFollowUp,
  unassignedTasksFollowUpIds: (state) => state.unassignedTasksFollowUpIds,
  unassignedTasksOverdue: (state) => state.unassignedTasksOverdue,
  unassignedTasksOverdueIds: (state) => state.unassignedTasksOverdueIds,
  taskId: (state) => state.taskId,
  taskName: (state) => state.taskName,
  formKey: (state) => state.formKey,
  processKey: (state) => state.processKey,
  processVersion: (state) => state.processVersion,
  externalProcessVersion: (state) => state.externalProcessVersion,
  processName: (state) => state.processName,
  deployedForm: (state) => state.deployedForm,
  extScript: (state) => state.extScript,
  savedGridLayout: (state) => state.savedGridLayout,
  sqlQueries: (state) => state.sqlQueries,
  taskData: (state) => state.taskData,
  candidateGroups: (state) => state.candidateGroups,
  candidateUsers: (state) => state.candidateUsers,
  historicTasks: (state) => state.historicTasks,
  teamTasks: (state) => state.teamTasks,
  teamTasksCount: (state) => state.teamTasksCount,
  teamTasksFollowUp: (state) => state.teamTasksFollowUp,
  teamTasksFollowUpIds: (state) => state.teamTasksFollowUpIds,
  teamTasksOverdue: (state) => state.teamTasksOverdue,
  teamTasksOverdueIds: (state) => state.teamTasksOverdueIds,
  allForms: (state) => state.allForms,
  processForms: (state) => state.processForms,
  formAction: (state) => state.formAction,
  formTitle: (state) => state.formTitle,
  formId: (state) => state.formId,
  subformList: (state) => state.subformList,
  subformExtScript: (state) => state.subformExtScript,
  subformSchema: (state) => state.subformSchema,
  subformTitle: (state) => state.subformTitle,
  subformLayout: (state) => state.subformLayout,
  subformQueries: (state) => state.subformQueries,
  processVars: (state) => state.processVars,
  caseId: (state) => state.caseId,
  exportedForm: (state) => state.exportedForm,
  formDeployed: (state) => state.formDeployed,
  formLocked: (state) => state.formLocked,
  formLockedUser: (state) => state.formLockedUser,
  lockedForms: (state) => state.lockedForms,
  apiReturnData: (state) => state.apiReturnData,
  apiAuthCode: (state) => state.apiAuthCode,
  veridasResp: (state) => state.veridasResp,
  taskComplete: (state) => state.taskComplete,
  promoteFormData: (state) => state.promoteFormData,
  promoteFormRes: (state) => state.promoteFormRes
};

const actions = {
  countMyTasks({commit}) {
    return axios.get(baseURL + '/task/count?assignee=' + store.state.currentUser, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('MY_TASKS_COUNT', result.data.count);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getMyTasks({rootState, commit}) {
    commit('MY_TASKS', []);
    let ref = this;

    return axios.get(baseURL + '/task?assignee=' + store.state.currentUser, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( async result => {
      let followUpReq = 0;
      let followUpIds = [];
      let overdue = 0;
      let overdueIds = [];
      let procDefIds = '';
      let procInstIds = '';

      if(result.data.length > 0) {
        for(let i = 0; i < result.data.length; i++) {
          // Add process definition ID to list
          if(procDefIds.indexOf(result.data[i].processDefinitionId) == -1) {
            procDefIds += result.data[i].processDefinitionId + ',';
          }
          // Add process instance ID to list
          procInstIds += result.data[i].processInstanceId + ',';
          // Check for follow up and due tasks
          let now = new Date();
          if(result.data[i].followUp != null && result.data[i].followUp != '') {
            let followUp = new Date(result.data[i].followUp);
            if(now > followUp) {
              followUpReq++;
              followUpIds.push(result.data[i].processInstanceId);
            }

            // Format date
            let fdate = new Date(result.data[i].followUp);
            Vue.set(result.data[i], 'followUp', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(fdate));
          }
          if(result.data[i].due != null && result.data[i].due != '') {
            let due = new Date(result.data[i].due);
            if(now > due) {
              overdue++;
              overdueIds.push(result.data[i].processInstanceId);
            }

            // Format date
            let odate = new Date(result.data[i].due);
            Vue.set(result.data[i], 'due', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(odate));
          }

          // Format date
          let date = new Date(result.data[i].created);
          Vue.set(result.data[i], 'created', new Intl.DateTimeFormat('en-GB', 
            {
              day: 'numeric',
              month: 'numeric', 
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: false
            }).format(date));
        }
      }

      // Get parent process (if this is a sub process)
      let subProcInstIds = await this.dispatch('searchForParent', result);
      procInstIds += subProcInstIds;

      procDefIds.replace(/,\s*$/, '');
      procInstIds.replace(/,\s*$/, '');
      
      await axios.get(baseURL + '/process-definition?processDefinitionIdIn=' + procDefIds, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( defData => {
        let procDefData = defData.data;

        result.data.forEach(function(item) {
          ref.dispatch('getCandidateGroups', item.id).then( () => {
            let canClaim = false;
            let candidateGroups = ref.getters['candidateGroups'];
            let candidateUsers = ref.getters['candidateUsers'];
            let userGroups = store.state.userGroups;
            
            if(candidateGroups.length > 0 && userGroups.length > 0) {
              for(let i = 0; i < candidateGroups.length; i++) {
                if(userGroups.indexOf(candidateGroups[i]) !== -1) {
                  canClaim = true;
                }
              }
            }
            
            if(candidateUsers.length > 0) {
              if(candidateUsers.indexOf(store.state.currentUser) !== -1) {
                canClaim = true;
              }
            }
            
            Vue.set(item, 'canClaim', canClaim);
          });

          procDefData.forEach(function(defItem) {
            if(defItem.id == item.processDefinitionId) {
              Vue.set(item, 'processName', defItem.name);
            }
          });
        });
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
      
      await axios.get(baseURL + '/process-instance/?processInstanceIds=' + procInstIds, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( async instData => {
        let procInstData = instData.data;

        // Get all labels
        await this.dispatch('getAllCaseLabels', procInstIds).then( () => {
          let caseLabels = JSON.parse(rootState.process.allCaseLabels);
          let caseData = [];

          procInstData.forEach(function(item, index) {
            // Match instance IDs
            for(let i = 0; i < result.data.length; i++) {
              if(result.data[i].processInstanceId == item.id) {
                // Check for a case ID, if null get one
                if(item.businessKey == null) {
                  let isSubProcess = false;
                  let caseLabel = '';

                  ref.dispatch('getSubParentData', result.data[i].processInstanceId).then( async subParent => {
                    if(result.data[i].processInstanceId != subParent.id) {
                      isSubProcess = true;
                    }
                    
                    if(isSubProcess) {
                      await ref.dispatch('getCaseLabelById', parseInt(subParent.businessKey)).then( () => {
                        caseLabel = rootState.process.getCaseLabel;
                      });
                    }else {
                      caseLabel = rootState.process.setCaseLabel;
                    }

                    let payload = {
                      'instanceId': result.data[i].processInstanceId,
                      'processId': result.data[i].processDefinitionId,
                      'caseLabel': caseLabel
                    };
                    ref.dispatch('setCaseId', payload).then( () => {
                      ref.dispatch('getCaseId', result.data[i].processInstanceId).then( () => {
                        Vue.set(result.data[i], 'caseId', rootState.process.getCaseId);
                        Vue.set(result.data[i], 'caseLabel', rootState.process.getCaseLabel);

                        caseData.push({ 
                          instanceId: result.data[i].processInstanceId,
                          processId: result.data[i].processDefinitionId,
                          caseId: result.data[i].caseId,
                          taskId: result.data[i].id,
                          assignee: result.data[i].assignee
                        });
                      });
                    });
                  });
                }else {
                  // Get the label
                  Vue.set(result.data[i], 'caseId', item.businessKey);
                  caseLabels.forEach(function(labelItem) {
                    if(labelItem.ID === parseInt(item.businessKey)) {
                      Vue.set(result.data[i], 'caseLabel', labelItem.CASE_LABEL);
                      return true;
                    }
                  });

                  caseData.push({ 
                    instanceId: result.data[i].processInstanceId,
                    processId: result.data[i].processDefinitionId,
                    caseId: result.data[i].caseId,
                    taskId: result.data[i].id,
                    assignee: result.data[i].assignee
                  });
                }
              }
            }
          });
          
          let data = {
            'variables': {
              'pType': { 'value': 'case', 'type': 'String' },
              'action': { 'value': 'getStatusAll', 'type': 'String' },
              'caseData': { 'value': JSON.stringify(caseData), 'type': 'String' },
            },
            'withVariablesInReturn': true
          }
          
          return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( status => {
            let caseStatuses = JSON.parse(status.data.variables.caseStatuses.value);
            let opened = false;
            
            caseStatuses.forEach(function(caseItem, index) {

              if(result.data[index].caseId == caseItem.CASE_ID) {
                if(caseItem.OPENED == null) {
                  opened = true;
                }else {
                  opened = caseItem.OPENED;
                }
              }
              Vue.set(result.data[index], 'opened', opened);
            });
          });
        });
        
        commit('MY_TASKS', result.data);
        commit('MY_TASKS_FOLLOW_UP', followUpReq);
        commit('MY_TASKS_FOLLOW_UP_IDS', followUpIds);
        commit('MY_TASKS_OVERDUE', overdue);
        commit('MY_TASKS_OVERDUE_IDS', overdueIds);
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getAllTasks({rootState, commit}) {
    commit('ALL_TASKS', []);
    let ref = this;

    return axios.get(baseURL + '/task', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( async result => {
      let followUpReq = 0;
      let followUpIds = [];
      let overdue = 0;
      let overdueIds = [];
      let procDefIds = '';
      let procInstIds = '';

      if(result.data.length > 0) {
        for(let i = 0; i < result.data.length; i++) {
          // Add process definition ID to list
          if(procDefIds.indexOf(result.data[i].processDefinitionId) == -1) {
            procDefIds += result.data[i].processDefinitionId + ',';
          }
          // Add process instance ID to list
          procInstIds += result.data[i].processInstanceId + ',';
          // Check for follow up and due tasks
          let now = new Date();
          if(result.data[i].followUp != null && result.data[i].followUp != '') {
            let followUp = new Date(result.data[i].followUp);
            if(now > followUp) {
              followUpReq++;
              followUpIds.push(result.data[i].processInstanceId);
            }

            // Format date
            let fdate = new Date(result.data[i].followUp);
            Vue.set(result.data[i], 'followUp', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(fdate));
          }
          if(result.data[i].due != null && result.data[i].due != '') {
            let due = new Date(result.data[i].due);
            if(now > due) {
              overdue++;
              overdueIds.push(result.data[i].processInstanceId);
            }

            // Format date
            let odate = new Date(result.data[i].due);
            Vue.set(result.data[i], 'due', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(odate));
          }

          // Format date
          let date = new Date(result.data[i].created);
          Vue.set(result.data[i], 'created', new Intl.DateTimeFormat('en-GB', 
            {
              day: 'numeric',
              month: 'numeric', 
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: false
            }).format(date));
        }
      }

      // Get parent process (if this is a sub process)
      let subProcInstIds = await this.dispatch('searchForParent', result);
      procInstIds += subProcInstIds;

      procDefIds.replace(/,\s*$/, '');
      procInstIds.replace(/,\s*$/, '');
      
      await axios.get(baseURL + '/process-definition?processDefinitionIdIn=' + procDefIds, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( defData => {
        let procDefData = defData.data;

        result.data.forEach(function(item) {
          ref.dispatch('getCandidateGroups', item.id).then( () => {
            let canClaim = false;
            let candidateGroups = ref.getters['candidateGroups'];
            let candidateUsers = ref.getters['candidateUsers'];
            let userGroups = store.state.userGroups;
            
            if(candidateGroups.length > 0 && userGroups.length > 0) {
              for(let i = 0; i < candidateGroups.length; i++) {
                if(userGroups.indexOf(candidateGroups[i]) !== -1) {
                  canClaim = true;
                }
              }
            }
            
            if(candidateUsers.length > 0) {
              if(candidateUsers.indexOf(store.state.currentUser) !== -1) {
                canClaim = true;
              }
            }
            
            Vue.set(item, 'canClaim', canClaim);
          });

          procDefData.forEach(function(defItem) {
            if(defItem.id == item.processDefinitionId) {
              Vue.set(item, 'processName', defItem.name);
            }
          });
        });
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
      
      await axios.get(baseURL + '/process-instance/?processInstanceIds=' + procInstIds, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( async instData => {
        let procInstData = instData.data;

        // Get all labels
        await this.dispatch('getAllCaseLabels', procInstIds).then( () => {
          let caseLabels = JSON.parse(rootState.process.allCaseLabels);

          procInstData.forEach(function(item, index) {
            // Match instance IDs
            for(let i = 0; i < result.data.length; i++) {
              if(result.data[i].processInstanceId == item.id) {
                // Check for a case ID, if null get one
                if(item.businessKey == null) {
                  let isSubProcess = false;
                  let caseLabel = '';

                  ref.dispatch('getSubParentData', result.data[i].processInstanceId).then( async subParent => {
                    if(result.data[i].processInstanceId != subParent.id) {
                      isSubProcess = true;
                    }
                    
                    if(isSubProcess) {
                      await ref.dispatch('getCaseLabelById', parseInt(subParent.businessKey)).then( () => {
                        caseLabel = rootState.process.getCaseLabel;
                      });
                    }else {
                      caseLabel = rootState.process.setCaseLabel;
                    }

                    let payload = {
                      'instanceId': result.data[i].processInstanceId,
                      'processId': result.data[i].processDefinitionId,
                      'caseLabel': caseLabel
                    };
                    ref.dispatch('setCaseId', payload).then( () => {
                      ref.dispatch('getCaseId', result.data[i].processInstanceId).then( () => {
                        Vue.set(result.data[i], 'caseId', rootState.process.getCaseId);
                        Vue.set(result.data[i], 'caseLabel', rootState.process.getCaseLabel);
                      });
                    });
                  });
                }else {
                  // Get the label
                  Vue.set(result.data[i], 'caseId', item.businessKey);
                  caseLabels.forEach(function(labelItem) {
                    if(labelItem.ID === parseInt(item.businessKey)) {
                      Vue.set(result.data[i], 'caseLabel', labelItem.CASE_LABEL);
                      return true;
                    }
                  });
                }
              }
            }
          });
        });

        commit('ALL_TASKS_COUNT', result.data.length);
        commit('ALL_TASKS', result.data);
        commit('ALL_TASKS_FOLLOW_UP', followUpReq);
        commit('ALL_TASKS_FOLLOW_UP_IDS', followUpIds);
        commit('ALL_TASKS_OVERDUE', overdue);
        commit('ALL_TASKS_OVERDUE_IDS', overdueIds);
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  countUnassignedTasks({commit}) {
    return axios.get(baseURL + '/task/count?unassigned=true&candidateUser=' + store.state.currentUser, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('UNASSIGNED_TASKS_COUNT', result.data.count);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getUnassignedTasks({rootState, commit}, payload) {
    commit('UNASSIGNED_TASKS', []);
    let ref = this;

    return axios.post(baseURL + '/task', payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( async result => {
      let followUpReq = 0;
      let followUpIds = [];
      let overdue = 0;
      let overdueIds = [];
      let procDefIds = '';
      let procInstIds = '';

      if(result.data.length > 0) {
        for(let i = 0; i < result.data.length; i++) {
          // Add process definition ID to list
          if(procDefIds.indexOf(result.data[i].processDefinitionId) == -1) {
            procDefIds += result.data[i].processDefinitionId + ',';
          }
          // Add process instance ID to list
          procInstIds += result.data[i].processInstanceId + ',';
          // Check for follow up and due tasks
          let now = new Date();
          if(result.data[i].followUp != null && result.data[i].followUp != '') {
            let followUp = new Date(result.data[i].followUp);
            if(now > followUp) {
              followUpReq++;
              followUpIds.push(result.data[i].processInstanceId);
            }

            // Format date
            let fdate = new Date(result.data[i].followUp);
            Vue.set(result.data[i], 'followUp', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(fdate));
          }
          if(result.data[i].due != null && result.data[i].due != '') {
            let due = new Date(result.data[i].due);
            if(now > due) {
              overdue++;
              overdueIds.push(result.data[i].processInstanceId);
            }

            // Format date
            let odate = new Date(result.data[i].due);
            Vue.set(result.data[i], 'due', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(odate));
          }

          // Format date
          let date = new Date(result.data[i].created);
          Vue.set(result.data[i], 'created', new Intl.DateTimeFormat('en-GB', 
            {
              day: 'numeric',
              month: 'numeric', 
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: false
            }).format(date));
        }
      }

      // Get parent process (if this is a sub process)
      let subProcInstIds = await this.dispatch('searchForParent', result);
      procInstIds += subProcInstIds;

      procDefIds.replace(/,\s*$/, '');
      procInstIds.replace(/,\s*$/, '');
      
      await axios.get(baseURL + '/process-definition?processDefinitionIdIn=' + procDefIds, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( defData => {
        let procDefData = defData.data;

        result.data.forEach(function(item) {
          procDefData.forEach(function(defItem) {
            if(defItem.id == item.processDefinitionId) {
              Vue.set(item, 'processName', defItem.name);
            }
          });
        });
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
      
      await axios.get(baseURL + '/process-instance/?processInstanceIds=' + procInstIds, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( async instData => {
        let procInstData = instData.data;

        // Get all labels
        await this.dispatch('getAllCaseLabels', procInstIds).then( () => {
          let caseLabels = JSON.parse(rootState.process.allCaseLabels);
          
          procInstData.forEach(function(item, index) {
            // Match instance IDs
            for(let i = 0; i < result.data.length; i++) {
              if(result.data[i].processInstanceId == item.id) {
                // Check for a case ID, if null get one
                if(item.businessKey == null) {
                  let isSubProcess = false;
                  let caseLabel = '';

                  ref.dispatch('getSubParentData', result.data[i].processInstanceId).then( async subParent => {
                    if(result.data[i].processInstanceId != subParent.id) {
                      isSubProcess = true;
                    }
                    
                    if(isSubProcess) {
                      await ref.dispatch('getCaseLabelById', parseInt(subParent.businessKey)).then( () => {
                        caseLabel = rootState.process.getCaseLabel;
                      });
                    }else {
                      caseLabel = rootState.process.setCaseLabel;
                    }

                    let payload = {
                      'instanceId': result.data[i].processInstanceId,
                      'processId': result.data[i].processDefinitionId,
                      'caseLabel': caseLabel
                    };
                    ref.dispatch('setCaseId', payload).then( () => {
                      ref.dispatch('getCaseId', result.data[i].processInstanceId).then( () => {
                        Vue.set(result.data[i], 'caseId', rootState.process.getCaseId);
                        Vue.set(result.data[i], 'caseLabel', rootState.process.getCaseLabel);
                      });
                    });
                  });
                }else {
                  // Get the label
                  Vue.set(result.data[i], 'caseId', item.businessKey);
                  caseLabels.forEach(function(labelItem) {
                    if(labelItem.ID === parseInt(item.businessKey)) {
                      Vue.set(result.data[i], 'caseLabel', labelItem.CASE_LABEL);
                      return true;
                    }
                  });
                }
              }
            }
          });
        });
        
        commit('UNASSIGNED_TASKS', result.data);
        commit('UNASSIGNED_TASKS_FOLLOW_UP', followUpReq);
        commit('UNASSIGNED_TASKS_FOLLOW_UP_IDS', followUpIds);
        commit('UNASSIGNED_TASKS_OVERDUE', overdue);
        commit('UNASSIGNED_TASKS_OVERDUE_IDS', overdueIds);
      });
      
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  async searchForParent({commit}, result) {
    let procInstIds = '';

    for (const item of result.data) {
      try {
        const topLevelParentId = await this.dispatch('getSubParent', item.processInstanceId);
        procInstIds += topLevelParentId + ',';
      } catch (error) {
        console.error('Error processing item:', error);
      }
    }

    return procInstIds;
  },
  async getSubParent({commit}, processInstanceId) {
    let currentId = processInstanceId;
  
    while (true) {
      try {
        const response = await axios.get(baseURL + '/process-instance', {
          params: { subProcessInstance: currentId },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + store.state.token
          }
        });

        if (response.data.length === 0) {
          // We've reached the top level process
          return currentId;
        }

        // Move up to the next level
        currentId = response.data[0].id;
      } catch (error) {
        console.error('Error fetching process instance:', error);
        throw new Error(`API ${error}`);
      }
    }         
  },
  async getSubParentData({commit}, processInstanceId) {
    let currentId = processInstanceId;
    let parentObj = {};
  
    while (true) {
      try {
        const response = await axios.get(baseURL + '/process-instance', {
          params: { subProcessInstance: currentId },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + store.state.token
          }
        });

        if (response.data.length === 0) {
          // We've reached the top level process
          return parentObj;
        }

        // Move up to the next level
        currentId = response.data[0].id;
        parentObj = response.data[0];
      } catch (error) {
        console.error('Error fetching process instance:', error);
        throw new Error(`API ${error}`);
      }
    }         
  },
  getTask({commit}, payload) {
    return axios.get(baseURL + '/task?processInstanceId=' + payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(result.data[0]) {  
        let data = {
          'taskId': result.data[0].id,
          'formKey': result.data[0].formKey
        };
        commit('UPDATE_TASK_DATA', data);
        commit('UPDATE_TASK_NAME', result.data[0].name);
      }else {
        let data = {
          'taskId': '',
          'formKey': ''
        };
        commit('UPDATE_TASK_DATA', data);
        commit('UPDATE_TASK_NAME', '');
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getExternalTask({rootState, commit}, payload) {
    return axios.get(baseURL + '/task?processInstanceId=' + payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {
      let data = {
        'taskId': result.data[0].id,
        'formKey': result.data[0].formKey
      };

      this.dispatch('getCaseId', payload).then( () => {
        commit('UPDATE_CASE_ID', rootState.process.getCaseId);
      });
      
      commit('UPDATE_TASK_DATA', data);
      commit('UPDATE_TASK_NAME', result.data[0].name);

      axios.get(baseURL + '/process-definition?processDefinitionId=' + result.data[0].processDefinitionId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( resp => {
        commit('UPDATE_PROCESS_NAME', resp.data[0].name);
      });
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  checkTask({commit}, payload) {
    return axios.get(baseURL + '/task?processInstanceId=' + payload.instanceId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let taskComplete = false;
      if(result.data.length == 0  || result.data[0].id != payload.taskId) {
        taskComplete = true;
      }
      commit('TASK_COMPLETE', taskComplete);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  claimTask({commit}, payload) {
    let data = {
      "userId": payload.userId
    }

    return axios.post(baseURL + '/task/' + payload.taskId + '/claim', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('CLAIM_TASK', result.data);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'This task has already been claimed by someone.';
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  getForm({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'retrieve', 'type': 'String' },
        'type': { 'value': 'single', 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'processVersion': { 'value': payload.processVersion, 'type': 'Integer' },
        'formKey': { 'value': payload.formKey, 'type': 'String' },
        'formAction': { 'value': payload.formAction, 'type': 'String' },
        'lockedBy': { 'value': payload.lockedBy, 'type': 'String' },
        'formId': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      
      let theForm = JSON.parse(JSON.parse(result.data.variables.retrievedForm.value));
      let theLayout = JSON.parse(JSON.parse(result.data.variables.gridLayout.value));
      let theQueries = JSON.parse(JSON.parse(result.data.variables.sqlQueries.value));
      let extScript = JSON.parse(JSON.parse(result.data.variables.extScript.value));
      
      commit('DEPLOYED_FORM', theForm);
      commit('FORM_TITLE', result.data.variables.formTitle.value);
      commit('EXT_SCRIPT', extScript[0].theScript);
      commit('GRID_LAYOUT', theLayout);
      commit('SQL_QUERIES', theQueries);
    }).catch(error => {
      if(error.message.includes('unexpected end of data at line 1 column 1 of the JSON data')) {
        let msg = 'Hmm...it looks like no form has been assigned to this task.';
        commit('ERROR_MESSAGE', msg);
      }
      throw new Error(`API ${error}`);
    });
  },
  getExternalForm({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'retrieve', 'type': 'String' },
        'type': { 'value': 'single', 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'processVersion': { 'value': payload.processVersion, 'type': 'Integer' },
        'formKey': { 'value': payload.formKey, 'type': 'String' },
        'formAction': { 'value': payload.formAction, 'type': 'String' },
        'lockedBy': { 'value': payload.lockedBy, 'type': 'String' },
        'formId': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      

      let theForm = JSON.parse(JSON.parse(result.data.variables.retrievedForm.value));
      let theLayout = JSON.parse(JSON.parse(result.data.variables.gridLayout.value));
      let theQueries = JSON.parse(JSON.parse(result.data.variables.sqlQueries.value));
      let extScript = JSON.parse(JSON.parse(result.data.variables.extScript.value));
      
      commit('DEPLOYED_FORM', theForm);
      commit('FORM_TITLE', result.data.variables.formTitle.value);
      commit('EXT_SCRIPT', extScript[0].theScript);
      commit('GRID_LAYOUT', theLayout);
      commit('SQL_QUERIES', theQueries);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getSubform({commit}, formKey) {
    let data = {
      'variables': {
        'action': { 'value': 'retrieve', 'type': 'String' },
        'type': { 'value': 'subform', 'type': 'String' },
        'formKey': { 'value': formKey, 'type': 'String' },
        'processVersion': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      
      let theForm = JSON.parse(JSON.parse(result.data.variables.retrievedForm.value));
      let theLayout = JSON.parse(JSON.parse(result.data.variables.gridLayout.value));
      let theQueries = JSON.parse(JSON.parse(result.data.variables.sqlQueries.value));
      
      commit('SUBFORM_SCHEMA', theForm);
      commit('SUBFORM_TITLE', result.data.variables.formTitle.value);
      commit('SUBFORM_EXT_SCRIPT', result.data.variables.extScript.value);
      commit('SUBFORM_LAYOUT', theLayout);
      commit('SUBFORM_QUERIES', theQueries);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Error: Subform not found.';
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  getAllForms({commit}) {
    let data = {
      'variables': {
        'action': { 'value': 'retrieve', 'type': 'String' },
        'type': { 'value': 'all', 'type': 'String' },
        'processVersion': { 'value': 0, 'type': 'Integer' },
        'formId': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      
      let allForms = JSON.parse(result.data.variables.allForms.value);
      
      commit('ALL_FORMS', allForms);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getProcessForms({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'retrieve', 'type': 'String' },
        'type': { 'value': 'processForms', 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'processVersion': { 'value': 0, 'type': 'Integer' },
        'formId': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      
      let processForms = JSON.parse(result.data.variables.processForms.value);
      
      commit('PROCESS_FORMS', processForms);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getSubFormList({commit}) {
    let data = {
      'variables': {
        'action': { 'value': 'retrieve', 'type': 'String' },
        'type': { 'value': 'subforms', 'type': 'String' },
        'processVersion': { 'value': 0, 'type': 'Integer' },
        'formId': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      
      let subformList = JSON.parse(result.data.variables.subforms.value);
      
      commit('SUBFORM_LIST', subformList);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getProcessVars({commit}, processKey) {
    let data = {
      'variables': {
        'action': { 'value': 'getVars', 'type': 'String' },
        'processKey': { 'value': processKey, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let processVars = [];

      if(JSON.parse(result.data.variables.processVars.value)) {
        processVars = JSON.parse(JSON.parse(result.data.variables.processVars.value));
      }

      commit('PROCESS_VARS', processVars);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  uploadForm({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'upload', 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'processVersion': { 'value': payload.processVersion, 'type': 'Integer' },
        'formKey': { 'value': payload.formKey, 'type': 'String' },
        'schema': { 'value': payload.schema, 'type': 'Json' },
        'formTitle': { 'value': payload.formTitle, 'type': 'String' },
        'gridLayout': { 'value': payload.gridLayout, 'type': 'Json' },
        'extScript': { 'value': payload.extScript, 'type': 'Json' },
        'formAction': { 'value': payload.formAction, 'type': 'String' },
        'formId': { 'value': payload.formId, 'type': 'Integer' },
        'isMulti': { 'value': payload.isMulti, 'type': 'Integer' },
        'isDeployed': { 'value': payload.isDeployed, 'type': 'Integer' },
        'isLocked': { 'value': payload.isLocked, 'type': 'Integer' },
        'lockedBy': { 'value': payload.lockedBy, 'type': 'String' },
        'sqlQueries': { 'value': payload.sqlQueries, 'type': 'Json' },
        'processVars': { 'value': payload.processVars, 'type': 'Json' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(typeof result.data.variables.lastId !== 'undefined') {
        commit('UPDATE_FORM_ID', result.data.variables.lastId.value);
      }
      commit('UPLOADED_FORM', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  markFormsDeployed({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'upload', 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'processVersion': { 'value': payload.processVersion, 'type': 'Integer' },
        'formAction': { 'value': 'deployed', 'type': 'String' },
        'formId': { 'value': 0, 'type': 'Integer' },
        'isMulti': { 'value': 0, 'type': 'Integer' },
        'isDeployed': { 'value': 1, 'type': 'Integer' },
        'isLocked': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('MARKED_FORMS', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  markFormsUndeployed({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'upload', 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'processVersion': { 'value': payload.processVersion, 'type': 'Integer' },
        'formAction': { 'value': 'undeployed', 'type': 'String' },
        'formId': { 'value': 0, 'type': 'Integer' },
        'isMulti': { 'value': 0, 'type': 'Integer' },
        'isDeployed': { 'value': 0, 'type': 'Integer' },
        'isLocked': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('UNMARKED_FORMS', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  copyForm({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'upload', 'type': 'String' },
        'formAction': { 'value': 'copy', 'type': 'String' },
        'formId': { 'value': payload.formId, 'type': 'Integer' },
        'newFormKey': { 'value': payload.newFormKey, 'type': 'String' },
        'processVersion': { 'value': 0, 'type': 'Integer' },
        'isMulti': { 'value': 0, 'type': 'Integer' },
        'isDeployed': { 'value': 0, 'type': 'Integer' },
        'isLocked': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {            
      commit('COPIED_FORM', payload.formId);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteForm({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'delete', 'type': 'String' },
        'formId': { 'value': payload.formId, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {            
      commit('DELETED_FORM', payload.formId);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getTaskData({commit}, instanceId) {
    return axios.get(baseURL + '/process-instance/' + instanceId + '/variables', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      commit('TASK_DATA', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getExternalTaskData({commit}, instanceId) {
    return axios.get(baseURL + '/process-instance/' + instanceId + '/variables', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {      
      commit('TASK_DATA', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  completeTask({commit}, data) {
    return axios.post(baseURL + '/task/' + data.taskId + '/complete', data.payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('COMPLETED_TASK', result.data);
    }).catch(error => {
      let msg = error.response.data.type + ': ' + error.response.data.message;
      commit('ERROR_MESSAGE', msg);
      throw new Error(`API ${error}`);
    });
  },
  completeExternalTask({commit}, data) {
    return axios.post(baseURL + '/task/' + data.taskId + '/complete', data.payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {
      commit('COMPLETED_TASK', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  saveTask({commit}, data) {
    if(!taskLocked) {
      taskLocked = true;
      return axios.post(baseURL + '/process-instance/' + data.instanceId + '/variables', data.payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
        commit('SAVED_TASK', result.data);
        taskLocked = false;
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
    }
  },
  saveExternalTask({commit}, data) {
    if(!taskLocked) {
      taskLocked = true;
      return axios.post(baseURL + '/process-instance/' + data.instanceId + '/variables', data.payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {
        commit('SAVED_TASK', result.data);
        taskLocked = false;
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
    }
  },
  getCandidateGroups({commit}, taskId) {
    return axios.get(baseURL + '/task/' + taskId + '/identity-links', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let candidateGroups = [];
      let candidateUsers = [];
      for(let i = 0; i < result.data.length; i++) {
        if(result.data[i].type == 'candidate' && result.data[i].groupId != null) {
          candidateGroups.push(result.data[i].groupId);
        }
        if(result.data[i].type == 'candidate' && result.data[i].userId != null) {
          candidateUsers.push(result.data[i].userId);
        }
      }
      commit('CANDIDATE_GROUPS', candidateGroups);
      commit('CANDIDATE_USERS', candidateUsers);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  reassignTask({commit}, payload) {
    let data = {
      'userId': payload.userId
    }
    return axios.post(baseURL + '/task/' + payload.taskId + '/assignee', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {
      if(res.status == 204) {
        commit('REASSIGNED_STATUS', 'success');
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  bulkReassignTasks({commit}, payload) {
    let data = {
      'userId': payload.userId
    }

    const PromiseArr = [];
    const items = payload.items;
    for(let i = 0; i < items.length; i++) {
      PromiseArr.push(
        axios.post(baseURL + '/task/' + items[i].id + '/assignee', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( resp => new Promise(resolve => 
          resolve(resp.status)))
      );
    }

    Promise.all(PromiseArr).then(res => {
      let success = true;
      res.forEach(function(item) {
        if(item != 204) {
          success = false;
        }
      });
      
      commit('BULK_REASSIGN', success);
    });
  },
  getHistoricTasks({rootState, commit}, payload) {
    let ref = this;

    return axios.get(baseURL + '/history/task?processInstanceId=' + payload.id + '&sortBy=startTime&sortOrder=asc', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      
      const PromiseArr = [];
      if(result.data.length > 0) {
        PromiseArr.push(
          axios.get(baseURL + '/history/detail?processInstanceId=' + payload.id + '&sortBy=time&sortOrder=asc', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( resp => new Promise(resolve => 
            resolve(resp.data)))
        );
      }

      Promise.all(PromiseArr).then(res => {
        
        res.forEach(function(item, index) {
          ref.dispatch('getCaseId', result.data[index].processInstanceId).then( () => {
            Vue.set(result.data[index], 'caseId', rootState.process.getCaseId);
            Vue.set(result.data[index], 'caseLabel', rootState.process.getCaseLabel);
          });
          
          for(let i = 0; i < result.data.length; i++) {
            let varData = [];
            
            for(let j = 0; j < item.length; j++) {
              
              if(item[j].variableName != 'allUsersGroups' && item[j].variableName != 'portalUser' && item[j].variableName != 'portalPassword') {
                let taskStart = new Date(result.data[i].startTime);
                let taskEnd = new Date(result.data[i].endTime);
                let varTime = new Date(item[j].time);
                
                // If varTime between task startTime and endTime
                if(varTime >= taskStart && varTime <= taskEnd) {
                  // Format the variable timestamp
                  let vdate = new Date(item[j].time);
                  item[j].time = new Intl.DateTimeFormat('en-GB', 
                  {
                    day: 'numeric',
                    month: 'numeric', 
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                    hour12: false
                  }).format(vdate);

                  varData.push(item[j]);
                }
              }
            }
            
            Vue.set(result.data[i], 'varData', varData);
            
            // Format dates
            let sdate = new Date(result.data[i].startTime);
            Vue.set(result.data[i], 'startTime', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(sdate));
            let edate = new Date(result.data[i].endTime);
            Vue.set(result.data[i], 'endTime', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(edate));
          }

        });

        commit('HISTORIC_TASKS', result.data);
      });
      
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getTeamTasks({rootState, commit}, payload) {
    commit('TEAM_TASKS', []);
    let ref = this;
    let ep = '';

    if(payload.groups == '') {
      ep = '/task?assigned=true';
    }else {
      ep = '/task?assigned=true&includeAssignedTasks=true&candidateGroups=' + payload.groups;
    }

    return axios.get(baseURL + ep + '&assigneeIn=' + payload.members, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( async result => {
      let followUpReq = 0;
      let followUpIds = [];
      let overdue = 0;
      let overdueIds = [];
      let procDefIds = '';
      let procInstIds = '';

      if(result.data.length > 0) {
        for(let i = 0; i < result.data.length; i++) {
          // Add process definition ID to list
          if(procDefIds.indexOf(result.data[i].processDefinitionId) == -1) {
            procDefIds += result.data[i].processDefinitionId + ',';
          }
          // Add process instance ID to list
          procInstIds += result.data[i].processInstanceId + ',';
          // Check for follow up and due tasks
          let now = new Date();
          if(result.data[i].followUp != null && result.data[i].followUp != '') {
            let followUp = new Date(result.data[i].followUp);
            if(now > followUp) {
              followUpReq++;
              followUpIds.push(result.data[i].processInstanceId);
            }

            // Format date
            let fdate = new Date(result.data[i].followUp);
            Vue.set(result.data[i], 'followUp', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(fdate));
          }
          if(result.data[i].due != null && result.data[i].due != '') {
            let due = new Date(result.data[i].due);
            if(now > due) {
              overdue++;
              overdueIds.push(result.data[i].processInstanceId);
            }

            // Format date
            let odate = new Date(result.data[i].due);
            Vue.set(result.data[i], 'due', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(odate));
          }

          // Format date
          let date = new Date(result.data[i].created);
          Vue.set(result.data[i], 'created', new Intl.DateTimeFormat('en-GB', 
            {
              day: 'numeric',
              month: 'numeric', 
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              hour12: false
            }).format(date));
        }
      }

      // Get parent process (if this is a sub process)
      let subProcInstIds = await this.dispatch('searchForParent', result);
      procInstIds += subProcInstIds;

      procDefIds.replace(/,\s*$/, '');
      procInstIds.replace(/,\s*$/, '');
      
      await axios.get(baseURL + '/process-definition?processDefinitionIdIn=' + procDefIds, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( defData => {
        let procDefData = defData.data;

        result.data.forEach(function(item) {
          procDefData.forEach(function(defItem) {
            if(defItem.id == item.processDefinitionId) {
              Vue.set(item, 'processName', defItem.name);
            }
          });
        });
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
      
      await axios.get(baseURL + '/process-instance/?processInstanceIds=' + procInstIds, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( async instData => {
        let procInstData = instData.data;

        // Get all labels
        await this.dispatch('getAllCaseLabels', procInstIds).then( () => {
          let caseLabels = JSON.parse(rootState.process.allCaseLabels);

          procInstData.forEach(function(item, index) {
            // Match instance IDs
            for(let i = 0; i < result.data.length; i++) {
              if(result.data[i].processInstanceId == item.id) {
                // Check for a case ID, if null get one
                if(item.businessKey == null) {
                  let isSubProcess = false;
                  let caseLabel = '';

                  ref.dispatch('getSubParentData', result.data[i].processInstanceId).then( async subParent => {
                    if(result.data[i].processInstanceId != subParent.id) {
                      isSubProcess = true;
                    }
                    
                    if(isSubProcess) {
                      await ref.dispatch('getCaseLabelById', parseInt(subParent.businessKey)).then( () => {
                        caseLabel = rootState.process.getCaseLabel;
                      });
                    }else {
                      caseLabel = rootState.process.setCaseLabel;
                    }

                    let payload = {
                      'instanceId': result.data[i].processInstanceId,
                      'processId': result.data[i].processDefinitionId,
                      'caseLabel': caseLabel
                    };
                    ref.dispatch('setCaseId', payload).then( () => {
                      ref.dispatch('getCaseId', result.data[i].processInstanceId).then( () => {
                        Vue.set(result.data[i], 'caseId', rootState.process.getCaseId);
                        Vue.set(result.data[i], 'caseLabel', rootState.process.getCaseLabel);
                      });
                    });
                  });
                }else {
                  // Get the label
                  Vue.set(result.data[i], 'caseId', item.businessKey);
                  caseLabels.forEach(function(labelItem) {
                    if(labelItem.ID === parseInt(item.businessKey)) {
                      Vue.set(result.data[i], 'caseLabel', labelItem.CASE_LABEL);
                      return true;
                    }
                  });
                }
              }
            }
          });
        });

        commit('TEAM_TASKS_COUNT', result.data.length);
        commit('TEAM_TASKS', result.data);
        commit('TEAM_TASKS_FOLLOW_UP', followUpReq);
        commit('TEAM_TASKS_FOLLOW_UP_IDS', followUpIds);
        commit('TEAM_TASKS_OVERDUE', overdue);
        commit('TEAM_TASKS_OVERDUE_IDS', overdueIds);
      });
      
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  exportForm({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'export', 'type': 'String' },
        'formId': { 'value': payload.formId, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    };
    
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let exportData = [];

      let fileName = payload.formTitle + '.frm';
      let fileData = result.data.variables.exportedForm.value;
      let mimeType = 'text/plain';

      let blob = new Blob([fileData], {type: mimeType});
      let url = window.URL.createObjectURL(blob);
      
      exportData.push({ fileName: fileName, fileData: url });
      
      commit('EXPORTED_FORM_DATA', exportData);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  importForm({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'import', 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'processVersion': { 'value': payload.processVersion, 'type': 'Integer' },
        'formKey': { 'value': payload.formKey, 'type': 'String' },
        'schema': { 'value': payload.schema, 'type': 'Json' },
        'formTitle': { 'value': payload.formTitle, 'type': 'String' },
        'gridLayout': { 'value': payload.gridLayout, 'type': 'Json' },
        'extScript': { 'value': payload.extScript, 'type': 'Json' },
        'formAction': { 'value': payload.formAction, 'type': 'String' },
        'isMulti': { 'value': payload.isMulti, 'type': 'Integer' },
        'isDeployed': { 'value': payload.isDeployed, 'type': 'Integer' },
        'isLocked': { 'value': payload.isLocked, 'type': 'Integer' },
        'sqlQueries': { 'value': payload.sqlQueries, 'type': 'Json' }
      }
    };
    
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      // Force a 1 second wait for local storage
      setTimeout(function(){
        commit('IMPORT_FORM_SAVED', true);
      }, 1000);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'Possible error in SQL statement. ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  lockCheck({commit}, payload) {
    let data = {};
    if(payload.checkType == 'single') {
      data = {
        'variables': {
          'action': { 'value': 'lockCheck', 'type': 'String' },
          'formId': { 'value': payload.formId, 'type': 'Integer' },
          'checkType': { 'value': payload.checkType, 'type': 'String' }
        },
        'withVariablesInReturn': true
      };
    }
    if(payload.checkType == 'all') {
      data = {
        'variables': {
          'action': { 'value': 'lockCheck', 'type': 'String' },
          'formId': { 'value': 0, 'type': 'Integer' },
          'checkType': { 'value': payload.checkType, 'type': 'String' },
          'processKey': { 'value': payload.processKey, 'type': 'String' },
          'processVersion': { 'value': payload.processVersion, 'type': 'Integer' }
        },
        'withVariablesInReturn': true
      };
    }
    if(payload.checkType == 'unlock') {
      data = {
        'variables': {
          'action': { 'value': 'lockCheck', 'type': 'String' },
          'formId': { 'value': payload.formId, 'type': 'Integer' },
          'checkType': { 'value': payload.checkType, 'type': 'String' }
        },
        'withVariablesInReturn': true
      };
    }
    if(payload.checkType == 'logoutUnlock') {
      data = {
        'variables': {
          'action': { 'value': 'lockCheck', 'type': 'String' },
          'formId': { 'value': 0, 'type': 'Integer' },
          'lockedByUser': { 'value': store.state.currentUser, 'type': 'String' },
          'checkType': { 'value': payload.checkType, 'type': 'String' }
        },
        'withVariablesInReturn': true
      };
    }
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      if(payload.checkType == 'single') {
        let retData = {
          'formDeployed': result.data.variables.formDeployed.value,
          'formLocked': result.data.variables.formLocked.value,
          'formLockedUser': result.data.variables.formLockedUser.value
        };
        commit('LOCK_CHECK', retData);
      }
      if(payload.checkType == 'all') {
        let lockedForms = JSON.parse(result.data.variables.lockedForms.value);
        commit('LOCK_CHECK_ALL', lockedForms);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  promoteFormsCheck({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'promote', 'type': 'String' },
        'promoteFormData': { 'value': payload.promotes, 'type': 'Json' },
        'checkType': { 'value': 'get', 'type': 'String' },
      },
      'withVariablesInReturn': true
    };
    return axios.post(payload.engine + '/engine-rest/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let formData = JSON.parse(result.data.variables.formData.value);
      commit('PROMOTE_FORM_DATA', formData);
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'API error: ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  promoteForms({commit}, payload) {
    let data = {
      'variables': {
        'action': { 'value': 'promote', 'type': 'String' },
        'promoteFormData': { 'value': payload.promotes, 'type': 'Json' },
        'checkType': { 'value': 'getLocal', 'type': 'String' },
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let formData = result.data.variables.formData.value;
      
      let data = {
        'variables': {
          'action': { 'value': 'promote', 'type': 'String' },
          'promoteFormData': { 'value': formData, 'type': 'Json' },
          'checkType': { 'value': 'update', 'type': 'String' },
        },
        'withVariablesInReturn': true
      };
      return axios.post(payload.engine + '/engine-rest/process-definition/key/formController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {        
        let retData = [];

        if(result.status == 200) {
          retData = JSON.parse(result.data.variables.retData.value);
        }

        commit('PROMOTE_FORM_RES', retData);
      }).catch(error => {
        if(error != 'TypeError: data is null') {
          let msg = 'API error: ' + error;
          commit('ERROR_MESSAGE', msg);
        }
      });
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'API error: ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  },
  async fireApi({state, commit}, payload) {
    state.apiReturnData = [];
    let mutationData = [];
    const PromiseArr = [];

    for(let i = 0; i < payload.length; i++) {

      let data = {
        'variables': {
          'requestType': { 'value': 'api', 'type': 'String' },
          'id': { 'value': payload[i].id, 'type': 'Integer' },
          'callType': { 'value': payload[i].type, 'type': 'String' },
          'apiParams': { 'value': payload[i].apiParams, 'type': 'String' },
          'apiHeaders': { 'value': payload[i].apiHeaders, 'type': 'String' },
          'urlQuery': { 'value': encodeURI(payload[i].urlQuery), 'type': 'String' },
          'postData': { 'value': payload[i].postData, 'type': 'String' },
          'includeClientId': { 'value': payload[i].includeClientId, 'type': 'Boolean' },
          'includeClientSecret': { 'value': payload[i].includeClientSecret, 'type': 'Boolean' },
          'includeGrantType': { 'value': payload[i].includeGrantType, 'type': 'Boolean' }
        },
        'withVariablesInReturn': true
      };

      PromiseArr.push(
        axios.post(baseURL + '/process-definition/key/apiController/tenant-id/harlequin/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( resp => new Promise(resolve => {
          if(typeof resp.data.variables.apiResponse !== 'undefined') {
            resolve(resp.data.variables.apiResponse.value)
          }else {
            resolve(JSON.stringify('{"apiResponse": "API error"}'))
          }
        }))
      );
    }

    Promise.all(PromiseArr).then(res => {
      res.forEach(function(item, index) {
        try {
          mutationData[index] = JSON.parse(JSON.parse(item));
        } catch (error) {
          mutationData[index] = JSON.parse(item);
        }
      });
      commit('API_DATA', mutationData);
    });
  },
  async veridasAuth({commit}, payload) {
    let data = {
      'variables': {
        'requestType': { 'value': 'veridas', 'type': 'String' },
        'documentType': { 'value': payload.documentType, 'type': 'String' },
        'mobileUrl': { 'value': payload.mobileUrl, 'type': 'String' },
        'mobileParams': { 'value': payload.mobileParams, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    await axios.post(baseURL + '/process-definition/key/apiController/tenant-id/harlequin/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => { 
      commit('VERIDAS_RESP', JSON.parse(JSON.parse(result.data.variables.veridasResponse.value)));
    }).catch(error => {
      if(error != 'TypeError: data is null') {
        let msg = 'API error: ' + error;
        commit('ERROR_MESSAGE', msg);
      }
    });
  }
};

const mutations = {
  MY_TASKS(state, payload) {
    state.myTasks = payload;
  },
  MY_TASKS_COUNT(state, payload) {
    state.myTasksCount = payload;
  },
  MY_TASKS_FOLLOW_UP(state, payload) {
    state.myTasksFollowUp = payload;
  },
  MY_TASKS_FOLLOW_UP_IDS(state, payload) {
    state.myTasksFollowUpIds = payload;
  },
  MY_TASKS_OVERDUE(state, payload) {
    state.myTasksOverdue = payload;
  },
  MY_TASKS_OVERDUE_IDS(state, payload) {
    state.myTasksOverdueIds = payload;
  },
  ALL_TASKS(state, payload) {
    state.allTasks = payload;
  },
  ALL_TASKS_COUNT(state, payload) {
    state.allTasksCount = payload;
  },
  ALL_TASKS_FOLLOW_UP(state, payload) {
    state.allTasksFollowUp = payload;
  },
  ALL_TASKS_FOLLOW_UP_IDS(state, payload) {
    state.allTasksFollowUpIds = payload;
  },
  ALL_TASKS_OVERDUE(state, payload) {
    state.allTasksOverdue = payload;
  },
  ALL_TASKS_OVERDUE_IDS(state, payload) {
    state.allTasksOverdueIds = payload;
  },
  UNASSIGNED_TASKS(state, payload) {
    state.unassignedTasks = payload;
  },
  UNASSIGNED_TASKS_COUNT(state, payload) {
    state.unassignedTasksCount = payload;
  },
  UNASSIGNED_TASKS_FOLLOW_UP(state, payload) {
    state.unassignedTasksFollowUp = payload;
  },
  UNASSIGNED_TASKS_FOLLOW_UP_IDS(state, payload) {
    state.unassignedTasksFollowUpIds = payload;
  },
  UNASSIGNED_TASKS_OVERDUE(state, payload) {
    state.unassignedTasksOverdue = payload;
  },
  UNASSIGNED_TASKS_OVERDUE_IDS(state, payload) {
    state.unassignedTasksOverdueIds = payload;
  },
  CLAIM_TASK(state, payload) {
    state.claimtask = payload;
  },
  UPDATE_TASK_DATA(state, payload) {
    state.taskId = payload.taskId;
    state.formKey = payload.formKey;
  },
  UPDATE_TASK_ID(state, payload) {
    state.taskId = payload;
  },
  UPDATE_TASK_NAME(state, payload) {
    state.taskName = payload;
  },
  UPDATE_FORM_KEY(state, payload) {
    state.formKey = payload;
  },
  UPDATE_PROCESS_KEY(state, payload) {
    state.processKey = payload;
  },
  UPDATE_PROCESS_VERSION(state, payload) {
    state.processVersion = payload;
  },
  UPDATE_EXTERNAL_PROCESS_VERSION(state, payload) {
    state.externalProcessVersion = payload;
  },
  UPDATE_PROCESS_NAME(state, payload) {
    state.processName = payload;
  },
  UPDATE_FORM_ACTION(state, payload) {
    state.formAction = payload;
  },
  UPDATE_FORM_ID(state, payload) {
    state.formId = payload;
  },
  DEPLOYED_FORM(state, payload) {
    state.deployedForm = payload;
  },
  FORM_TITLE(state, payload) {
    state.formTitle = payload;
  },
  EXT_SCRIPT(state, payload) {
    state.extScript = payload;
  },
  GRID_LAYOUT(state, payload) {
    state.savedGridLayout = payload;
  },
  SQL_QUERIES(state, payload) {
    state.sqlQueries = payload;
  },
  PROCESS_VARS(state, payload) {
    state.processVars = payload;
  },
  UPLOADED_FORM(state, payload) {
    state.uploadedForm = payload;
  },
  COPIED_FORM(state, payload) {
    state.copiedForm = payload;
  },
  DELETED_FORM(state, payload) {
    state.deletedForm = payload;
  },
  TASK_DATA(state, payload) {
    state.taskData = payload;
  },
  COMPLETED_TASK(state, payload) {
    state.completedTask = payload;
  },
  SAVED_TASK(state, payload) {
    state.savedTask = payload;
  },
  CANDIDATE_GROUPS(state, payload) {
    state.candidateGroups = payload;
  },
  CANDIDATE_USERS(state, payload) {
    state.candidateUsers = payload;
  },
  REASSIGNED_STATUS(state, payload) {
    state.reassignedStatus = payload;
  },
  HISTORIC_TASKS(state, payload) {
    state.historicTasks = payload;
  },
  TEAM_TASKS(state, payload) {
    state.teamTasks = payload;
  },
  TEAM_TASKS_COUNT(state, payload) {
    state.teamTasksCount = payload;
  },
  TEAM_TASKS_FOLLOW_UP(state, payload) {
    state.teamTasksFollowUp = payload;
  },
  TEAM_TASKS_FOLLOW_UP_IDS(state, payload) {
    state.teamTasksFollowUpIds = payload;
  },
  TEAM_TASKS_OVERDUE(state, payload) {
    state.teamTasksOverdue = payload;
  },
  TEAM_TASKS_OVERDUE_IDS(state, payload) {
    state.teamTasksOverdueIds = payload;
  },
  PREVIEW_LOADED(state, payload) {
    state.previewLoaded = payload;
  },
  ALL_FORMS(state, payload) {
    state.allForms = payload;
  },
  PROCESS_FORMS(state, payload) {
    state.processForms = payload;
  },
  SUBFORM_LIST(state, payload) {
    state.subformList = payload;
  },
  SUBFORM_SCHEMA(state, payload) {
    state.subformSchema = payload;
  },
  SUBFORM_TITLE(state, payload) {
    state.subformTitle = payload;
  },
  SUBFORM_LAYOUT(state, payload) {
    state.subformLayout = payload;
  },
  SUBFORM_QUERIES(state, payload) {
    state.subformQueries = payload;
  },
  SUBFORM_EXT_SCRIPT(state, payload) {
    state.subformExtScript = payload;
  },
  MARKED_FORMS(state, payload) {
    state.markedForms = payload;
  },
  UNMARKED_FORMS(state, payload) {
    state.unmarkedForms = payload;
  },
  UPDATE_CASE_ID(state, payload) {
    state.caseId = payload;
  },
  BULK_REASSIGN(state, payload) {
    state.bulkReassign = payload;
  },
  GRID_ROW_ADDED(state, payload) {
    state.gridRowAdded = payload;
  },
  EXPORTED_FORM_DATA(state, payload) {
    state.exportedForm = payload;
  },
  IMPORT_FORM_SAVED(state, payload) {
    state.importFormSaved = payload;
  },
  EDITING_FORM(state, payload) {
    state.editingForm = payload;
  },
  LOCK_CHECK(state, payload) {
    state.formDeployed = payload.formDeployed;
    state.formLocked = payload.formLocked;
    state.formLockedUser = payload.formLockedUser;
  },
  LOCK_CHECK_ALL(state, payload) {
    state.lockedForms = payload;
  },
  API_DATA(state, payload) {
    state.apiReturnData = payload;
  },
  API_AUTH_CODE(state, payload) {
    state.apiAuthCode = payload;
  },
  VERIDAS_RESP(state, payload) {
    state.veridasResp = payload;
  },
  TASK_COMPLETE(state, payload) {
    state.taskComplete = payload;
  },
  PROMOTE_FORM_DATA(state, payload) {
    state.promoteFormData = payload;
  },
  PROMOTE_FORM_RES(state, payload) {
    state.promoteFormRes = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}